/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenu from './ActionsMenu'

// Define the props interface based on ActionsMenu props, excluding isBigMenu since it's always true
interface MenuAction {
  (): void
}

interface MenuSubSubItem {
  action?: MenuAction
  label?: string
  disabled?: boolean
  value?: string
  title?: string
}

interface MenuSubItem {
  action?: MenuAction
  label?: string
  disabled?: boolean
  value?: string
  title?: string
  subSubmenu?: MenuSubSubItem[]
}

interface MenuItemData {
  action?: MenuAction
  label?: string
  disabled?: boolean
  value?: string
  title?: string
  submenu?: MenuSubItem[]
  divider?: boolean
}

interface ActionsMenuBigProps {
  items: MenuItemData[]
  menuId: string
  onSelect?: (eventKey: string) => void
  onToggle?: (isOpen: boolean) => void
}

const ActionsMenuBig: React.FC<ActionsMenuBigProps> = (props) => {
  return <ActionsMenu isBigMenu {...props} />
}

export default ActionsMenuBig
